import {
  Bone,
  FieldSkeleton,
  HeaderSkeleton,
  Line,
  PanelSkeleton,
  pick,
  placeholderKeys,
  SkeletonRegion,
} from '@ems/ui/patterns/skeleton-blocks'

const ROW_WIDTHS = ['w-32', 'w-24', 'w-40', 'w-28'] as const

function RowsSkeleton({ count, tall }: { count: number; tall: boolean }) {
  return (
    <ul className="divide-y divide-(--border)">
      {placeholderKeys('row', count).map((key, at) => (
        <li
          key={key}
          className={
            tall ? 'flex items-center gap-3 py-3' : 'flex min-h-11 items-center gap-3 py-2'
          }
        >
          <Line width={pick(ROW_WIDTHS, at)} className="flex-1" />
          {tall ? <Bone className="h-8 w-40" /> : null}
        </li>
      ))}
    </ul>
  )
}

const PREVIEW_KEYS = placeholderKeys('preview', 4)

export function FormBuilderSkeleton() {
  return (
    <SkeletonRegion className="flex flex-col gap-6">
      <HeaderSkeleton
        title="w-44"
        description="w-80"
        actions={['h-9 w-24 lg:hidden', 'h-9 w-28']}
      />
      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,28rem)]">
        <div className="flex min-w-0 flex-col gap-6">
          <PanelSkeleton title="w-36" description="w-72">
            <RowsSkeleton count={2} tall={false} />
          </PanelSkeleton>
          <PanelSkeleton title="w-40" description="w-80">
            <RowsSkeleton count={4} tall />
          </PanelSkeleton>
          <PanelSkeleton title="w-32" description="w-64">
            <RowsSkeleton count={3} tall />
          </PanelSkeleton>
        </div>
        <PanelSkeleton title="w-20" description="w-56" className="hidden md:p-4 lg:flex">
          {PREVIEW_KEYS.map((key) => (
            <FieldSkeleton key={key} label="w-28" />
          ))}
        </PanelSkeleton>
      </div>
    </SkeletonRegion>
  )
}
